// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"fdc61ea2","377":"ac327b1b"}[chunkId] + ".chunk.js";
};